import React from 'react';
import { personalInfo, education } from '../data/portfolioData';
import { FaGraduationCap, FaUser } from 'react-icons/fa';
import Icon from './Icon';
import useScrollReveal from '../hooks/useScrollReveal';
import './About.css';

const About: React.FC = () => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="about" className="section about" ref={ref}>
      <div className={`container ${isVisible ? 'revealed' : 'hidden-section'}`}>
        <h2 className="section-title animate-fade-in-up">Chi Sono</h2>
        <p className="section-subtitle animate-fade-in-up delay-100">
          Un po' di cose su di me e su quello che faccio.
        </p>

        <div className="about-grid">
          <div className="about-image-wrapper animate-fade-in-up delay-200">
            <div className="about-image-placeholder">
              {personalInfo.avatarUrl ? (
                <img src={personalInfo.avatarUrl} alt={personalInfo.name} className="profile-image" />
              ) : (
                <div className="profile-placeholder">
                  <Icon icon={FaUser} />
                  <span className="profile-initials">LD</span>
                </div>
              )}
            </div>
            <div className="about-image-frame"></div>
          </div>

          <div className="about-text animate-fade-in-up delay-300">
            <h3>{'// chi-sono'}</h3>
            {personalInfo.bio.split('\n').map((paragraph, i) => (
              <p key={i}>{paragraph.trim()}</p>
            ))}

            <div className="about-stats">
              <div className="stat">
                <div className="stat-number">5+</div>
                <div className="stat-label">Anni di esperienza</div>
              </div>
              <div className="stat">
                <div className="stat-number">6+</div>
                <div className="stat-label">Clienti enterprise</div>
              </div>
              <div className="stat">
                <div className="stat-number">20+</div>
                <div className="stat-label">Tecnologie</div>
              </div>
            </div>
          </div>
        </div>

        {/* Sezione Formazione */}
        <div className="about-education animate-fade-in-up delay-400">
          <h3 className="education-title">
            <Icon icon={FaGraduationCap} /> Formazione
          </h3>
          <div className="education-list">
            {education.map(edu => (
              <div key={edu.id} className="education-item">
                <div className="education-item-title">{edu.title}</div>
                {edu.institution && (
                  <div className="education-item-institution">{edu.institution}</div>
                )}
                {edu.period && (
                  <div className="education-item-period">{edu.period}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
